import { inject, Pipe, PipeTransform } from "@angular/core";
import { AccountService } from "@modules/account/services/account.service";
import { Conversion, Fiat, Price } from "@models";
import { convertFiatToTradable } from "@helpers/tradable-convert";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { stripFunnyInput } from "@helpers/utils";
import { FiatService } from "@main-services/currency/fiat.service";

@Pipe({
	name: "convert_fiat_to_tradable",
	standalone: false
})
export class ConvertFiatToTradablePipe implements PipeTransform {
	public constructor(
		private accountService: AccountService,
		private tradableListService: TradableListService
	) {}

	private get defaultFiat(): Fiat {
		return this.accountService.getDefaultFiat();
	}

	public transform(value: string | number, id: string): number {
		value = stripFunnyInput(value);
		return convertFiatToTradable(this.defaultFiat, +value, this.tradableListService.getItemById(id));
	}
}

/**
 * A more advance fiat to tradeable pipe
 * it takes Fiat, Amount and Conversion as arguments
 */
@Pipe({
	name: "convert_fiat_to_tradable_dynamic",
	standalone: false
})
export class ConvertFiatToTradableDynamicPipe implements PipeTransform {
	private conversion = new Conversion();

	public transform(value: string | number, options: IFiatToTradableConversionOptions): number {
		if (!value) {
			return 0;
		}
		this.conversion.setFiatAmount(options.price.getPrice().getFiat());
		return convertFiatToTradable(options.fiat, +value, this.conversion);
	}
}

@Pipe({
	name: "fiat_exists_check",
	standalone: false
})
export class FiatExistsCheckPipe implements PipeTransform {
	private fiatService = inject(FiatService);

	public transform(value: string): boolean {
		if (!value) {
			return false;
		}
		return !!this.fiatService.getItemById(value);
	}
}

export interface IFiatToTradableConversionOptions {
	price: Price;
	fiat: Fiat;
}
